/**
 * Modern Base64 encoding/decoding utility
 * Replaces deprecated btoa/atob methods
 */

// Encode string to base64
export function encodeBase64(str) {
  try {
    // For modern browsers, use TextEncoder and btoa
    if (typeof TextEncoder !== 'undefined') {
      const encoder = new TextEncoder()
      const bytes = encoder.encode(str)
      const binaryString = Array.from(bytes, byte => String.fromCharCode(byte)).join('')
      return btoa(binaryString)
    } else {
      // Fallback for older browsers
      return btoa(unescape(encodeURIComponent(str)))
    }
  } catch (error) {
    console.error('Error encoding to base64:', error)
    return ''
  }
}

// Decode base64 to string
export function decodeBase64(base64Str) {
  try {
    // For modern browsers, use atob and TextDecoder
    if (typeof TextDecoder !== 'undefined') {
      const binaryString = atob(base64Str)
      const bytes = new Uint8Array(binaryString.length)
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      const decoder = new TextDecoder()
      return decoder.decode(bytes)
    } else {
      // Fallback for older browsers
      return decodeURIComponent(escape(atob(base64Str)))
    }
  } catch (error) {
    console.error('Error decoding from base64:', error)
    return ''
  }
}

// Generate a unique response ID using base64 encoding
export function generateResponseId(empId) {
  const timestamp = Date.now()
  const uniqueString = `response_${timestamp}_${empId}`
  return encodeBase64(uniqueString)
}

// Decode response ID to get original string
export function decodeResponseId(responseId) {
  return decodeBase64(responseId)
} 